module.exports = __webpack_public_path__ + "static/img/DISA-bird.c1c55c3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src-detail/img/DISA-bird.jpeg
// module id = q+5C
// module chunks = 1